import React, { useEffect, useState, useRef } from 'react';

const NotFoundPage = () => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          backgroundColor: '#11181C',
          color: '#fff',
          padding: '20px',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: '72px', margin: '0', fontWeight: '700' }}>404</h1>
        <p style={{ fontSize: '24px', margin: '20px 0', fontWeight: '600' }}>
          ページが見つかりません
        </p>
        <p style={{ fontSize: '16px', color: 'rgba(255, 255, 255, 0.6)', marginBottom: '40px' }}>
          該当するページは存在しません
        </p>
      </div>
    );
};
  
export default NotFoundPage;